import styled from 'styled-components'
import {airBlue, boxShadow, lightGray} from '@modifi/colors'
import {Row, Col} from '@modifi/ui'

export const CompanyOwnershipType = styled(Row)<{isSelected?: boolean}>`
  border: solid 1px ${({isSelected}): string | null => (isSelected ? airBlue : lightGray)};
  margin-top: 8px;
  margin-bottom: 8px;
  padding: 16px;
  cursor: pointer;
  border-radius: 6px;

  &:hover {
    box-shadow: ${boxShadow};
  }
`

export const OwnershipContainer = styled(Row)<{disabled?: boolean}>`
  pointer-events: ${({disabled}): string => (disabled ? 'none' : 'auto')};
  margin-left: 0px;
  margin-right: 0px;
`

export const HiddenInput = styled.input`
  position: absolute;
  left: -99999px;
`

export const Label = styled.label`
  display: block;

  ${CompanyOwnershipType} {
    transition: border-color 200ms ease, box-shadow 200ms ease;
  }
`

export const StyledCol = styled(Col)`
  text-align: center;
`
